"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const store_1 = require("@/state/store");
const dataLayerLogin_1 = require("@/services/dataLayerLogin");
const SharedButton_vue_1 = __importDefault(require("@SharedVueComponents/SharedButton.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AppleLogin',
    setup(__props) {
        function startAppleLogin() {
            window.location.href = `${store_1.store.oAuthSignIn}?kc_idp_hint=apple`;
            (0, dataLayerLogin_1.pushEvent)("AppleButton");
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SharedButton_vue_1.default, {
                variant: "secondary",
                "append-icon": "social-apple",
                "icon-prefix": false,
                "aria-label": "Apple Anmeldung",
                onClick: startAppleLogin
            }));
        };
    }
});
